import React from 'react';
import {FaCalendar} from "react-icons/fa";
import {FaFileCircleExclamation, FaLocationPin, FaTriangleExclamation} from "react-icons/fa6";
import {useEdgeBuilder} from "../../../association-network-context.jsx";
import DivisorItem from "./divisor-item.jsx";
import projectUtils from "../../../../../../../utils/project-utils.js";
import Button from "../../../../../../../components/button/button.jsx";
import {navigateHook} from "../../../../../../../hooks/use-navigate.js";

const BoDetails = ({data}) => {
    const navigate = navigateHook();
    const {boName} = useEdgeBuilder();

    const open = () => {
        const {id} = data;

        const url = `/bos/${id.replace("/", "-")}`

        navigate(url, true);
    }

    const getNature = () => {
        const reasons = JSON.parse(data.reasons);
        return reasons.map(r => r.name).join(', ');
    }

    return (
        <>
            <p className={`text-[16px] font-bold text-white p-2 bg-[#c5c5c5] mb-0`}>{`${boName} - ${data.id}`}</p>
            <div className={"p-2"}>
                <DivisorItem icon={<FaCalendar size={18}/>} text={"Data"} value={projectUtils.formatDate(data.dateTimeFactIni)}/>
                <DivisorItem icon={<FaFileCircleExclamation size={18}/>} text={"Natureza"} value={getNature()}/>
                <DivisorItem icon={<FaLocationPin size={18}/>} text={"Endereço"} value={data.address}/>
                <DivisorItem icon={<FaTriangleExclamation size={18}/>} text={"Flagrante"} value={data.flagrant}/>

                <Button onClick={open}>
                    Abrir cadastro
                </Button>
            </div>
        </>
    )
}

export default BoDetails;